import axios from '@/lib/axios';
import { toast } from 'sonner';

export function buildSelfRegistrationPayload(ticketId: string) {
  return {
    registrations: [
      {
        ticketId,
        attendee: { type: 'self' as const },
        formData: {},
      },
    ],
  };
}

export async function instantSelfRegister(eventId: string, ticketId: string): Promise<boolean> {
  try {
    await axios.post(
      `/api/events/${eventId}/bulk-register`,
      buildSelfRegistrationPayload(ticketId)
    );
    return true;
  } catch (error: unknown) {
    const err = error as { response?: { data?: { error?: string; details?: string } } };
    const message =
      err.response?.data?.error ||
      err.response?.data?.details ||
      'Registration failed. Please try again.';
    toast.error(message);
    return false;
  }
}
